module.exports = __webpack_public_path__ + "img/philosopher.9a154d6c.png";